

export interface Offer {
    ClientKey?: string;
    Id: string;
    StartDate: Date | string;
    EndDate: Date | string;
    Name: string;
    OfferAsset?: string;
    Headline?: string;
    BodyCopy?: string;
    Disclaimer?: string;
    ClientComment?: string;
    SalePrice?: number;
    Status?: string;
    Rank: number;
    TargetURL: string;
    AdRetailPrice?: number;
    UnitOfMeasure: string;
    Quantity?: number;
    PercentOff?: number;
    DollarOff?: number;
    BuyQuantity?: number;
    GetQuantity?: number;
    Limit?: string;
    WhenYouBuy?: number;
    SaveAmount?: number;
    selected?: boolean;
    BadgeAssetId?: string;
    OfferTypeId?: string;
    Version?: string;
}
